/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import { Alert } from ".";
import { withErrorBoundary } from "react-error-boundary";

export type FormProps = React.ComponentPropsWithRef<"form"> & {
  errors: Array<string>;
};

const Form = React.forwardRef<HTMLFormElement, FormProps>((props, ref) => {
  const { children, errors, ...rest } = props;

  return (
    <form ref={ref} {...rest}>
      {errors && errors.length != 0 && (
        <Alert>
          {errors.map((error, index) => {
            return <div key={index}>{error}</div>;
          })}
        </Alert>
      )}
      {children}
    </form>
  );
});

Form.displayName = "Form";

export default withErrorBoundary(Form, {
  onError(error, info) {
    console.info(info);
    console.error(error);
  }
});
